import {mapGetters} from "vuex";
import remove from "../../mixins/remove";

export default {
    name: "partner-types",
    data() {
        return {

        }
    },
    computed: {
        ...mapGetters({
            items: 'partnerTypes/_getItems',
        }),
        headers() {
            return [
                {text: 'Title', value: "name"},
                {
                    text: 'Edit',
                    value: "actions",
                    align: "end",
                },
            ];
        },
    },
    methods: {
        removeItem() {
            this.$store.dispatch("partnerTypes/deleteItem", this.selected);
            this.clearDialog();
        },
    },
    created() {
        this.$store.dispatch("partnerTypes/getItems");
    },
    mixins: [remove],
};
